import React from 'react';

import { Box, Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { CONSTRUCTION_BUDGET_COLUMN_KEY } from '../../Construction.constants';
import { getBudgetRowStyles, summaryRowStyles } from '../../Construction.styles';
import { formatMoney, formatPercent } from '../../Construction.utils';
import PercentMeter from '../PercentMeter';

import { costCodeCellStyles, negativeValueStyles } from './BudgetTableSection.styles';

const KEY = CONSTRUCTION_BUDGET_COLUMN_KEY;

const getRowStyles = row =>
  row.isSummaryRow ? summaryRowStyles : getBudgetRowStyles(row.isOverBudget);

const renderMoney = (value, isNegative = false) => (
  <Typography sx={isNegative ? negativeValueStyles : undefined} variant="medium14">
    {formatMoney(value)}
  </Typography>
);

export const getBudgetTableConfig = () => ({
  [KEY.COST_CODE]: {
    label: 'Cost Code',
    align: 'left',
    customStyles: getRowStyles,
    content: row => (
      <Box sx={costCodeCellStyles}>
        <Typography variant={row.isSummaryRow ? 'bold14' : 'medium14'}>{row.costCode}</Typography>
        {row.isOverBudget && (
          <LabelCDS size={LabelSize.S} title="Over budget" variant={LabelVariant.ORANGE} />
        )}
      </Box>
    ),
  },
  [KEY.DESCRIPTION]: {
    label: 'Description',
    align: 'left',
    customStyles: getRowStyles,
    content: row => (
      <Typography color="text.secondary" variant="regular14">
        {row.description}
      </Typography>
    ),
  },
  [KEY.BUDGETED]: {
    label: 'Budgeted',
    align: 'right',
    customStyles: getRowStyles,
    content: row => renderMoney(row.budgeted),
  },
  [KEY.FUNDED_TO_DATE]: {
    label: 'Funded to Date',
    align: 'right',
    customStyles: getRowStyles,
    content: row => renderMoney(row.fundedToDate),
  },
  [KEY.THIS_DRAW]: {
    label: 'This Draw',
    align: 'right',
    customStyles: getRowStyles,
    content: row => renderMoney(row.thisDraw),
  },
  [KEY.REMAINING]: {
    label: 'Remaining',
    align: 'right',
    customStyles: getRowStyles,
    content: row => renderMoney(row.remaining, row.remaining < 0),
  },
  [KEY.PERCENT_COMPLETE]: {
    label: '% Complete',
    align: 'right',
    customStyles: getRowStyles,
    content: row =>
      row.isSummaryRow ? (
        <Typography variant="bold14">{formatPercent(row.percentComplete)}</Typography>
      ) : (
        <PercentMeter isOverBudget={row.isOverBudget} percent={row.percentComplete} />
      ),
  },
});
